<template>
  <div>
    <!-- there is a bug with labels on add-on fields, that's why the label has to be separated as work-around -->
    <fob-label :label="label" :asterisk="asterisk"></fob-label>
    <b-field
        class="fob-select"
        :type="derivedType"
        grouped
      >
      <b-autocomplete
          expanded
          ref="select"
          max-results="100"
          v-model="selectModel.displayName"
          placeholder="Tippen oder klicken um zu suchen"
          :data="selectModel.data"
          :loading="selectModel.isFetching"
          :icon="icon"
          field="_stringRep"
          @click.native="clicked"
          @input="getAsyncData"
          @select="emitChange">

          <template slot-scope="props">
            <h3>
              <fob-entity-decorator :resourceData="props.option">
                {{ props.option._stringRep }}
              </fob-entity-decorator>
            </h3>
            <small class="has-text-basalt">{{ props.option.parentOrgaName }}</small>
          </template>
      </b-autocomplete>
      <p v-if="extraButton" class="control">
        <b-tooltip square position="is-top" :label="$gettext(extraButton.tooltip)">
          <button tabindex="-1" @click="$emit('custom', {name: extraButton.event})" class="button is-aquamarine">
            <b-icon :icon="extraButton.icon" size="is-small"></b-icon>
          </button>
        </b-tooltip>
      </p>
      <p v-if="allowCreate" class="control" style="margin-left: 3px">
        <b-tooltip square position="is-top" :label="$gettext(`${label}.plusbutton`)">
          <button tabindex="-1" @click="prepareCreation" class="button is-aquamarine">
            <b-icon icon="plus" size="is-small"></b-icon>
          </button>
        </b-tooltip>
      </p>
      <p class="control">
        <b-tooltip square position="is-top" :label="$gettext('form.xbutton')">
          <button tabindex="-1" @click="emptyField" class="button is-aquamarine">
            <b-icon icon="times" size="is-small"></b-icon>
          </button>
        </b-tooltip>
      </p>
    </b-field>
    <fob-entity-create-modal
      :active.sync="showCreateModal"
      :schema="schema"
      :field="label.split('.').splice(-1)[0]"
      @submit="submitCreated"
      v-model="created">
    </fob-entity-create-modal>
  </div>
</template>

<script>
import api from '@/api'
import entityCreateModal from '@/components/form/EntityCreateModal'
import Label from '@/components/form/Label'
import EntityDecorator from '@/components/EntityDecorator'

export default {
  name: 'fob-entity-select',
  components: {
    'fob-entity-create-modal': entityCreateModal,
    'fob-entity-decorator': EntityDecorator,
    'fob-label': Label
  },
  data () {
    return {
      justEmptied: false,
      selectModel: {
        data: [],
        displayName: this.value ? this.value._stringRep : '',
        isFetching: false
      },
      lastSelected: null,
      created: null,
      showCreateModal: false
    }
  },
  props: {
    route: String,
    schema: Object,
    type: String,
    allowCreate: {
      type: Boolean,
      default: true
    },
    method: Object,
    label: String,
    asterisk: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    extraButton: Object,
    value: {
      type: Object,
      default () {
        return {
          name: ''
        }
      }
    }
  },
  computed: {
    autocomplete () {
      return api.methods.autocomplete(this.route, this.method.name)
    },
    derivedType () {
      if (this.value != null && this.value.name !== undefined && this.value.name !== '') {
        return 'is-success'
      } else {
        return this.type
      }
    }
  },
  mounted () {
    this.lastSelected = this.value
    /*
    When the input field of the b-autocomplete is changed, the
    `selected` attribute will be set to `null`. If this is a an actual
    change (e.g. from some value to null), the `select` event will be
    triggered.

    If we set a value when mounting the component, the `selected`
    attribute is not set automatically and hence the `select` event
    will not be triggered when changing the value. This code
    circumvents this behaviour.
    */
    if (this.value) {
      this.$refs.select.setSelected(this.value)
    }
  },
  watch: {
    value () {
      // needed to update field when value is set by changing value
      this.$refs.select.setSelected(this.value)
    }
  },
  methods: {
    prepareCreation () {
      if (this.created == null) {
        let Constructor = this.schema.class
        this.created = new Constructor({
          _id: `__${Date.now()}`,
          _entityName: 'de.ul.fob.domain.AbstractPerson'
        })
      }
      this.showCreateModal = true
    },
    submitCreated () {
      // avoid direct wiring of person in create modal and data in select
      let Constructor = this.schema.class
      let newPerson = new Constructor(this.created)
      newPerson._stringRep = this.schema.preliminaryStringRep(newPerson)
      this.selectModel.data = [ newPerson ]
      this.$refs.select.setSelected(newPerson)
      this.showCreateModal = false
      this.emitChange(newPerson)
    },
    emitChange (option) {
      if (this.lastSelected !== option) {
        if (option) {
          this.$emit('input', option)
          this.lastSelected = option
        } else {
          this.$emit('input', null)
          this.lastSelected = null
        }
      }
    },
    emptyField () {
      this.justEmptied = true
      this.created = null
      this.$emit('input', { name: '' })
      this.selectModel.displayName = ''
    },
    clicked () {
      if (!this.$refs.select.isActive) {
        this.getAsyncData()
      }
    },
    getAsyncData (currentDisplayName) {
      if (!this.justEmptied) {
        if (this.value === null || this.value.name === '' || (currentDisplayName != null && currentDisplayName !== this.value._stringRep)) {
          if (this.method.minLength === 0 || (currentDisplayName != null && currentDisplayName.length >= this.method.minLength)) {
            let param
            if (this.method.multiValue) {
              if (currentDisplayName != null) {
                param = currentDisplayName.split(/\s+/).filter(x => x !== '')
              } else {
                param = ''
              }
            } else {
              param = currentDisplayName || ''
            }

            let opts = this.method.opts || {}

            this.selectModel.data = []
            this.selectModel.isFetching = true
            this.autocomplete({ rep: param, ...opts })
                .then(({ data }) => {
                  data.forEach((item) => {
                    this.selectModel.data.push(item)
                  })
                  this.selectModel.isFetching = false
                  this.$refs.select.isActive = true
                }, response => {
                  this.selectModel.isFetching = false
                })
          }
        }
      } else {
        this.selectModel.data = []
        this.justEmptied = false
      }
    }
  }
}
</script>

<style>
  .fob-select .dropdown-content {
    max-height: 400px;
    max-width: 800px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/EntitySelect.vue